import React, { useContext, useState } from 'react'
import AppContext from '../context'
import { Checkbox, Tag } from '@missionlabs/smartagent-app-components';

interface Props {

}

const BasketDiscounts: React.FC<Props> = () => {
    const { cart } = useContext(AppContext);

    const [requireDiscount, setRequireDiscount] = useState(false);
    const [discountDesc, setDiscountDesc] = useState(false);
    const [addTenPercent, setAddTenPercent] = useState(false);
    const [freeDelivery, setFreeDelivery] = useState(false);

    return (
        <section className="height-half">
            <header className="row between">
                <h2>Discounts</h2>
                <Tag small type="red">
                    Check supervisor guidelines
                </Tag>
            </header>
            {!!cart && (
                <div className="row column sm-pad">
                    <div className="row border-bottom xsm-pad-vertical">
                        <Checkbox
                            disabled
                            square
                            checked={requireDiscount}
                            onChange={setRequireDiscount}
                            label="Does the customer require a discount?"
                        />
                    </div>

                    {requireDiscount && (
                        <div className="row column sm-pad-top">
                            <Checkbox
                                square
                                checked={discountDesc}
                                onChange={setDiscountDesc}
                                label="Discount description"
                            />

                            <Checkbox
                                square
                                checked={addTenPercent}
                                onChange={setAddTenPercent}
                                label="Add 10% Discount"
                            />

                            <Checkbox
                                square
                                checked={freeDelivery}
                                onChange={setFreeDelivery}
                                label="Add free delivery"
                            />
                        </div>
                    )}
                </div>
            )}
        </section>
    )
}




export default BasketDiscounts
